import { useEffect, useState } from "react";
import Reveal from "./Reveal";
import { Instagram } from "lucide-react";
import { SITE } from "../config/siteConfig";

const API = process.env.REACT_APP_BACKEND_URL;

export default function InstagramSection() {
  const count = SITE.instagramPlaceholderCount;
  const [posts, setPosts] = useState(null); // null = wird geladen

  useEffect(() => {
    let aktiv = true;
    fetch(`${API}/api/instagram/posts`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("feed"))))
      .then((d) => {
        if (aktiv) setPosts(d.posts || []);
      })
      .catch(() => {
        if (aktiv) setPosts([]);
      });
    return () => {
      aktiv = false;
    };
  }, []);

  const echtePosts = (posts || []).slice(0, count);
  return (
    <section id="instagram" className="py-16 md:py-28" data-testid="section-instagram">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <Reveal>
          <p className="eyebrow text-brand-dark">
            <span className="eyebrow-rule" aria-hidden="true" />
            Instagram
          </p>
          <h2 className="h2 mt-4">Die Hitsstube auf Instagram</h2>
          <p className="mt-5 max-w-[62ch] text-base leading-relaxed md:text-lg">
            {SITE.instagramText}
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
          {echtePosts.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.06}>
              <a
                data-testid={`instagram-post-${i + 1}`}
                href={p.permalink}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block aspect-square overflow-hidden rounded-md border border-line bg-paperlight"
                aria-label="Instagram-Post von @hitsstube öffnen"
              >
                {p.image_url ? (
                  <img
                    src={p.image_url}
                    alt={p.caption ? p.caption.slice(0, 100) : "Instagram-Post von @hitsstube"}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.04]"
                  />
                ) : (
                  p.video_url && (
                    <video
                      className="h-full w-full object-cover"
                      src={p.video_url}
                      muted
                      playsInline
                    />
                  )
                )}
                <span className="absolute right-2 top-2 flex h-8 w-8 items-center justify-center rounded-md bg-ink/70 text-paper opacity-0 transition-opacity duration-200 group-hover:opacity-100">
                  <Instagram className="h-4 w-4" aria-hidden="true" />
                </span>
              </a>
            </Reveal>
          ))}
          {!echtePosts.length &&
            Array.from({ length: count }).map((_, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <a
                  data-testid={`instagram-placeholder-${i + 1}`}
                  href={SITE.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card-tile flex aspect-square flex-col items-center justify-center gap-3 p-4 text-center transition-colors duration-200 hover:border-brand-red"
                >
                  <Instagram className="h-6 w-6 text-brand-red" aria-hidden="true" />
                  <span className="text-sm font-semibold text-ink/60">
                    Instagram-Post folgt
                  </span>
                </a>
              </Reveal>
            ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10">
            {SITE.instagramUrl ? (
              <a
                data-testid="instagram-follow-button"
                href={SITE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                <Instagram className="h-5 w-5" aria-hidden="true" />
                Auf Instagram folgen
              </a>
            ) : (
              <span
                data-testid="instagram-follow-button-pending"
                className="inline-flex min-h-[48px] items-center gap-2 rounded-md border-2 border-dashed border-line px-6 text-base font-semibold text-ink/60"
              >
                <Instagram className="h-5 w-5" aria-hidden="true" />
                Instagram-Profil folgt in Kürze
              </span>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
